<template>
	<div class="newpagepicklist">
		
		<div style="display: flex;">
			<div class="print-ttp">
				<div id="printTest">
					<div class="print-area"  v-if="newPrintData.length">
						<!-- 大于4个sku,一页显示2张 -->
						<div>
							<div v-if="visable" v-for="item in overFiveList">
								<div  class="content-item-five" >
									<div class="picklist-item-five" v-for="(ttp) in item">
										<div>
											<!-- 头部 -->
											<div style="display: flex;justify-content: space-between;align-items: center;font-size: 12px;">
												
												<div>
													<div style="font-size: 15px;">
														<span >No.{{ttp.NO+1}}</span>
														<span style="margin-left: 13px;">Order ID:{{ttp.orderId}}</span>
													</div>
													<div style="margin-top: 10px;">
														<span style="margin-right:15px">{{ttp.shopId}}</span>
														<span style="margin-right:15px">{{ttp.logistics}}</span>
														<span style="color: red;">Total：{{getQty(ttp)}}</span>
													</div>
												</div>
												<div style="display: flex;flex-direction: column;">
													<span style="text-align:right">{{ttp.printNum+1}}nd print</span>
													<div style="text-align:right">Pick up</div>
													<span style="text-align:right">Last Shipout：{{ttp.shipByDate}}</span>
												</div>
											</div>
											<!-- 订单详情 -->
											<div style="margin-top: 15px;">
													<div style="display: flex;justify-content: space-between;border-bottom: 1px #eee solid;">
														<span >#</span>
														<span >P sku</span>
														<span >W sku </span>
														<span >Position</span>
														<span >Qty</span>
													</div>
													<div style="display: flex;justify-content: space-between;font-size: 12px;border-bottom: 1px #eee solid;" v-for="(ccp,index) in ttp.items">
														<span class="header-tip" >{{index+1}}</span>
														<span class="header-tip spec" >{{ccp.storeItem ? ccp.storeItem.itemSku : ccp.itemSku}}</span>
														<span class="header-tip spec" >{{ccp.storeItem ?  ccp.storeItem.skuName : ccp.skuName}}</span>
														<span class="header-tip" >{{ccp.storeItem ? ccp.storeItem.address : $t('other.a354')}}</span>
														<span class="header-tip spec" >{{ccp.variationQuantityPurchased}}</span>
													</div>
													<div style="font-size: 12px;margin-top:10px">
														buyer`s info：<span >{{ttp.buyerName}}</span> <span style="margin-left: 10px;">{{ttp.buyerPhone}}</span>
													</div>
												<!-- <div style="width: 150px;height: 150px;border: 1px #000 solid;">
													<div style="line-height:48px;text-align:center;height:50px;border-bottom:1px solid #000">{{ttp.shopId}}</div>
													<div style="line-height:48px;text-align:center;height:50px;border-bottom:1px solid #000">{{ttp.logistics}}</div>
													<div style="line-height:48px;text-align:center;height:50px;">
														<span style="display:inline-block;width:49%;border-right: 1px solid #000;">Total</span>
														<span style="display:inline-block;width:50%;font-size: 18px;font-weight: bold;color: red;">{{getQty(ttp)}}</span>
													</div>
												</div> -->
											</div>
										</div>
										<div style="position: absolute;top: 40%;left: 30%;font-size: 80px;opacity: 0.3;color: red;">NO.{{ttp.NO+1}}</div>
										<!-- 脚部 -->
										<!-- <div >
											<span style="display: inline-block;width: 80px;height: 80px;margin-right: 5px;position: relative;" v-for="(ccp,index) in ttp.items">
												<span >
													<img style="width: 100%;" :src="ccp.image" />
													<span style="position: absolute;border: 1px red solid;top: 0;right: 0;width: 25px;height: 25px;background-color: #fff;text-align: center;border-radius: 50%;">{{ccp.variationQuantityPurchased}}</span>
													<span>#{{index+1}}</span>
												</span>
											</span>
										</div> -->
									</div>
								</div>
								<div style="page-break-after:always"></div>	
							</div>
						</div>
						
						
						
						<!-- 小于4个sku,一页显示4张 -->
						<div v-if="visable" v-for="item in newPrintData">
							<div  class="content-item" >
								<div class="picklist-item" v-for="(ttp) in item">
									<div >
										
										<!-- 头部 -->
										<div style="display: flex;justify-content: space-between;align-items: center;font-size: 12px;">
											<div style="font-size: 15px;">
												<span >No.{{ttp.NO+1}}</span>
												<span style="margin-left: 13px;">Order ID:{{ttp.orderId}}</span>
											</div>
											<div style="display: flex;flex-direction: column;">
												<span style="text-align:right">{{ttp.printNum+1}}nd print</span>
												<div style="text-align:right">Pick up</div>
												<span style="text-align:right">Last Shipout：{{ttp.shipByDate}}</span>
											</div>
										</div>
										<!-- 订单详情 -->
										<div style="display: flex;justify-content: space-between;">
											<div>
												<div style="border-bottom: 1px #eee solid;">
													<span class="header-tip">#</span>
													<span class="header-tip">P sku</span>
													<span class="header-tip">W sku </span>
													<span class="header-tip">Position</span>
													<span class="header-tip">Qty</span>
												</div>
												<div style="font-size: 12px;border-bottom: 1px #eee solid;" v-for="(ccp,index) in ttp.items">
													<span class="header-tip" >{{index+1}}</span>
													<span class="header-tip spec" >{{ccp.storeItem ? ccp.storeItem.itemSku : ccp.itemSku}}</span>
													<span class="header-tip spec" >{{ccp.storeItem ? ccp.storeItem.skuName : ccp.skuName}}</span>
													<span class="header-tip" >{{ccp.storeItem ? ccp.storeItem.address : $t('other.a354')}}</span>
													<span class="header-tip spec" >{{ccp.variationQuantityPurchased}}</span>
												</div>
												<div style="font-size: 12px;margin-top:10px">
													buyer`s info：<span >{{ttp.buyerName}}</span> <span style="margin-left: 10px;">{{ttp.buyerPhone}}</span>
												</div>
											</div>
											
											<div style="width: 150px;height: 150px;border: 1px #000 solid;">
												<div style="line-height:48px;text-align:center;height:50px;border-bottom:1px solid #000">{{ttp.shopId}}</div>
												<div style="line-height:48px;text-align:center;height:50px;border-bottom:1px solid #000">{{ttp.logistics}}</div>
												<div style="line-height:48px;text-align:center;height:50px;">
													<span style="display:inline-block;width:49%;border-right: 1px solid #000;">Total</span>
													<span style="display:inline-block;width:50%;font-size: 18px;font-weight: bold;color: red;">{{getQty(ttp)}}</span>
												</div>
											</div>
										</div>
									</div>
									
									<div style="position: absolute;top: 40%;left: 30%;font-size: 80px;opacity: 0.3;color: red;">NO.{{ttp.NO+1}}</div>
									<!-- 脚部 -->
									<div >
										<span style="display: inline-block;width: 80px;height: 80px;margin-right: 5px;position: relative;" v-for="(ccp,index) in ttp.items">
											<span >
												<img style="width: 100%;" :src="ccp.image" />
												<span style="position: absolute;border: 1px red solid;top: 0;right: 0;width: 25px;height: 25px;background-color: #fff;text-align: center;border-radius: 50%;">{{ccp.variationQuantityPurchased}}</span>
												<span>#{{index+1}}</span>
											</span>
										</span>
									</div>
								</div>
							</div>
							<div style="page-break-after:always"></div>	
						</div>
					</div>
				</div>
			
						
			</div>
			
		
		<div class="operate-area">
			<div class="orderpage-btn">
				<el-button  size="mini" type="primary" v-print="'#printTest'">{{$t('other.a342')}}</el-button>
			</div>
			<!-- <div style="margin:30px 0 0 15px">
				<el-switch
				  style="display: block"
				  v-model="visable"
				  active-color="#13ce66"
				  inactive-color="#ff4949"
				  active-text="每页/4张"
				  inactive-text="每页/1张">
				</el-switch>
			</div> -->
		
			
		</div>
		
		</div>
		
		
	</div>
	
</template>
<script>
import utils from '../utils/utils'
	import {
		mapState,
	     mapActions,
	} from 'vuex'
	import loading from './loading.vue'
	import Papa from 'papaparse'
	import json2csv from 'json2csv'
	import csvExportor from "csv-export";
	export default {
	    data() {
	      return {
	        th_printdata:[],
			options: [{
			          value: 1,
			          label: this.$t('other.a493')
			        }, {
			          value: 2,
			          label: this.$t('other.a494')
			        }, {
			          value: 3,
			          label: this.$t('other.a495')
			        }],
					value:1,
					sliderStyle:{
						width:'210mm',
						height:'270mm'
					},
					widthValue:'',
					heightValue:'',
					newPrintData:[],
					visable:true,
					overFiveList:[]
		  }
	    },
		components:{
			loading
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId
			}),
		
			
		},
		created(){
	
			this.init()
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
				
			]),
			
			getImg(){
				let pdfheader='data:application/pdf;base64,'
				dataURI=pdfheader + 'WvNTXJfJrwIUf8M2Q2SOiW5YZyeLQzzzB6qR9Q6Mx8kEwbW8KlTLOGQ07jeE4MPOVexa95EpwXw9VrEJ77VM8tRAhAp66Chh0gtqIi5CAJWEj1ee%2B%2B2cMjpo4JogDxysAgujdmISGsB4CJQQ%2BM8I%2FfEPVFSl2K3n3nQhwE1us%2FnpdtFK%2FAnjbbOkRWm%2FDuh5mrGThAUI5%2Bikcrv2DY1oJc1IjzNi7YQWlMDcgEMPxE6W7kPQL1rbUiIML%2B9i2c8OI%2FgvG8ifekeU627xflo5HOh1MuEVUVwU2YNr%2BQcvdzKbBhx9BflrR%2BHjxzmOJH3yiLSFVTuL4Grf4zpLntZPBA%3D%3D'
			    return dataURI
			},
			
			chosePage(){
				console.log(this.value)
				if(this.value == 1){
					this.sliderStyle.width='210mm'
					this.sliderStyle.height='297mm'
				}else if(this.value == 2){
					this.sliderStyle.width='148mm'
					this.sliderStyle.height='210mm'
				}else if(this.value == 3){
					this.sliderStyle.width='100mm'
					this.sliderStyle.height='150mm'
					this.widthValue='100'
					this.heightValue='150'
				}
			},
			
			oop1(){
				
				this.sliderStyle.height=this.heightValue + 'mm'
			},
			oop(){
				console.log(this.widthValue)
				this.sliderStyle.width=this.widthValue + 'mm'
			},
			//从storage上拿下将要打印的item
			init(){
				
				const newStr='printcontent'
				const newStr2="printcontentOver5"
				
				this.newPrintData=this.createNew(newStr,4)
				this.overFiveList=this.createNew(newStr2,2)
				console.log(this.overFiveList)
				console.log(this.newPrintData)
				
				
			},
			
			// 拆分数组
			createNew(arrStr,num){
				console.log(arrStr)
				let arr=JSON.parse(localStorage.getItem(arrStr))
				let list=[]
				// let arr=this.th_printdata
				
				for (var index = 0; index < arr.length;) {
				  list.push(arr.slice(index,index +=num));
				}
				
				return list
				
			},
			
			getQty(item){
				let total=0
				item.items.forEach(p => {
					total +=p.variationQuantityPurchased
				})
				return total
			},
			
			getAmount(item){
				let total=0
				item.items.forEach(p => {
					total +=p.variationOriginalPrice
				})
				return total
			},
			
			
			getTiem(time) {
				console.log(time)
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(10, time.indexOf('.'))
				return time
			},
		}
	  }
</script>

<style>
	.newpagepicklist{
		width: 100%;
		background: #fff;
		z-index: 99999;
		position: absolute;
	
	}
	
	.header-tip{
		display: inline-block;
		width: 90px;
		word-break:break-all
		
	}
	
	.header-tip-copy{
		display: inline-block;
		width: 120px;
	}
	.header-tip:nth-child(1),.header-tip:nth-child(5){
		width: 40px!important;
	}
	
	.newpagepicklist .print-content-left{
		width: 70%;
		
		
	}
	.newpagepicklist .childer-item{
		width: 150px;
	}
	
	.newpagepicklist .orderpage-box{
		display: flex;
		position: relative;
	}

	
	.newpagepicklist .print-ttp{
		position: relative;
		width: 80%;
		overflow-y: auto;
		height: 100vh;
		background: rgb(0, 0, 0);
	}
	
	
	.content-item-five::after{
		content: " ";
		position: absolute;
		height: 100%;
		width: 0px;
		left: 50%;
		margin-left: -1px;
		top: 0px;
		border-left: 2px dashed rgb(0, 0, 0);
	}
	
	
	
	
	.content-item::before{
		content: " ";
		position: absolute;
		height: 0px;
		width: 100%;
		top: 50%;
		margin-top: -1px;
		left: 0px;
		border-bottom: 2px dashed rgb(0, 0, 0);
	}
	
	.content-item::after{
		content: " ";
		position: absolute;
		height: 100%;
		width: 0px;
		left: 50%;
		margin-left: -1px;
		top: 0px;
		border-left: 2px dashed rgb(0, 0, 0);
	}

	.content-item,.content-item-five{
		display: flex;
		flex-wrap: wrap;
		width: 29.7cm;
		height: 20.5cm;
		background-color: #fff;
		position: relative;
		margin: 10px auto auto auto;
	}
	.picklist-item{
		width: 50%;
		height: 50%;
		box-sizing: border-box;
		padding: 5px 10px 0 10px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		
	}
	
	.picklist-item-five{
		width: 50%;
		
		box-sizing: border-box;
		padding: 5px 10px 0 10px;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
	}
	.newpagepicklist #printTest{
		position: relative;
	}
	
	.newpagepicklist .print-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 16px;
	}
	.newpagepicklist .print-content{
		display: flex;
		justify-content: space-between;
		min-height: 400px;
		font-size: 14px;
	}
	
	
	.newpagepicklist .content-left-item{
		display: inline-block;
		width: 130px;
		text-align: center;
	
		
	}
	
	.newpagepicklist .number{

		margin-left: 50px;
		
		
	}


	
	.spec{
		color: red;
		font-size: 14px;
		font-weight: bold;
	}
	
	.newpagepicklist .orderpage-btn{
		margin: 10px 10px;
		
	}
	
	.newpagepicklist .operate-area{
		flex: 1;
	}
	
	.newpagepicklist .el-popper{
		z-index: 999999!important;
	}
	
	.Afore{
		width: 20.5cm;
		min-height: 29.7cm;
		background-color: #fff;
		position: relative;
		margin: 10px auto auto auto;
		box-sizing: border-box;
		padding: 20px;
	}
	
	.img-box{
		width: 50px;
		margin-right: 70px;
	}


	
	
	
	
	
</style>
